import axios from 'axios';

export default {
    async getTax(params = {}) {
        return axios.get('/api/enduser/calculate/tax', { params })
    },

    async getFees(params = {}) {
        return axios.get('/api/enduser/get-fees', { params })
    },

};
